import React, { useEffect, useRef, useState } from 'react';
import './slider.css';
import { AiOutlineDoubleLeft, AiOutlineDoubleRight } from 'react-icons/ai';
import { toast } from 'sonner';
const Img1 = 'https://cdn.nudus.app/Images/carrousel/1.png';
const Img2 = 'https://cdn.nudus.app/Images/carrousel/2.png';
const Img3 = 'https://cdn.nudus.app/Images/carrousel/3.png';
const Img4 = 'https://cdn.nudus.app/Images/carrousel/4.png';
const Img5 = 'https://cdn.nudus.app/Images/carrousel/5.png';
const Img1mobile = 'https://cdn.nudus.app/Images/carrousel/mobile/1.png';
const Img2mobile = 'https://cdn.nudus.app/Images/carrousel/mobile/2.png';
const Img3mobile = 'https://cdn.nudus.app/Images/carrousel/mobile/3.png';
const Img4mobile = 'https://cdn.nudus.app/Images/carrousel/mobile/4.png';
const Img5mobile = 'https://cdn.nudus.app/Images/carrousel/mobile/5.png';

const Slider = ({ showTitles = true }) => {
  const slideShow = useRef(null);
  const intervalSlide = useRef(null);
  const [isMobile, setIsMobile] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    localidad: '',
    material: '',
    consumidor: '',
  });

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 500);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const moveSlide = () => {
    if (!slideShow.current) return;
    const primerElemento = slideShow.current.children[0];
    slideShow.current.style.transform = `translateX(-100%)`;
    slideShow.current.style.transition = `0.5s ease all`;

    const transicion = () => {
      slideShow.current.style.transition = 'none';
      slideShow.current.style.transform = 'translateX(0%)';
      slideShow.current.appendChild(primerElemento);
      slideShow.current.removeEventListener('transitionend', transicion);
    };

    slideShow.current.addEventListener('transitionend', transicion);
  };

  const backSlide = () => {
    if (slideShow.current.children.length > 0) {
      const lastElement = slideShow.current.children[slideShow.current.children.length - 1];
      slideShow.current.insertBefore(lastElement, slideShow.current.firstChild);
      slideShow.current.style.transition = `none`;
      slideShow.current.style.transform = `translateX(-100%)`;
      setTimeout(() => {
        slideShow.current.style.transform = `translateX(0%)`;
        slideShow.current.style.transition = `0.5s ease all`;
      }, 3);
    }
  };

  const startAutoSlide = () => {
    if (intervalSlide.current) clearInterval(intervalSlide.current);
    intervalSlide.current = setInterval(() => {
      moveSlide();
    }, 10000);
  };

  useEffect(() => {
    startAutoSlide();
    return () => clearInterval(intervalSlide.current);
  }, []);

  const validateForm = () => {
    const { name, email, phone, localidad, material, consumidor } = formData;
    if (!name || !email || !phone || !localidad || !material || !consumidor) {
      toast.error("Por favor completa todos los campos");
      return false;
    }
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(email)) {
      toast.error("Por favor ingresa un correo electrónico válido");
      return false;
    }
    if (phone.length < 6 || isNaN(phone)) {
      toast.error("Por favor ingresa un número de teléfono válido");
      return false;
    }
    return true;
  };

  const submitToGoogleForm = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    try {
      await fetch("https://docs.google.com/forms/d/e/1FAIpQLSc4WCt1dVahfYsFi9gQn1K73oD6j8rDwA8gzjEUH4XDXsJvCQ/formResponse", {
        method: "POST",
        mode: "no-cors",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams({
          "entry.782456827": formData.name,
          "entry.1495591910": formData.email,
          "entry.910051675": formData.phone,
          "entry.858834568": formData.localidad,
          "entry.1478018999": formData.material,
          "entry.555546106": formData.consumidor
        }).toString()
      });
      toast.success("Formulario enviado correctamente");
    } catch (error) {
      console.error("Error al enviar el formulario", error);
      toast.error("Error al enviar el formulario");
    }
  };

  const imagesDesktop = [Img2, Img3, Img4, Img5];
  const imagesMobile = [Img2mobile, Img3mobile, Img4mobile, Img5mobile];

  return (
    <div className="slider-container">
      <div className="arrows-container">
        <span onClick={() => { backSlide(); startAutoSlide(); }}><AiOutlineDoubleLeft /></span>
        <span onClick={() => { moveSlide(); startAutoSlide(); }}><AiOutlineDoubleRight /></span>
      </div>

      <div className="slider-show-container" ref={slideShow}>
        {/* Primer slide con formulario */}
        <div
          className="slider"
          style={{ backgroundImage: `url(${isMobile ? Img1mobile : Img1})` }}
        >
          <div className="first-slide-wrapper">
            <div className="first-slide-text" style={{ display: showTitles ? 'block' : 'none' }}>
              <h1>COMERCIALIZAMOS<br />MATERIALES PARA LA CONSTRUCCIÓN</h1>
              <p style={{ display: 'none' }}>
                Formá parte de Lumadi: accedé a precios exclusivos, asesoramiento personalizado
                y los mejores productos para tu negocio o proyecto personal.
              </p>
            </div>
            <form style={{ display: 'none' }} onSubmit={submitToGoogleForm} className={`first-slide-form desktop`}>
              <h3>COMPLETÁ EL FORMULARIO PARA QUE NUESTRO EQUIPO TE CONOZCA MEJOR</h3>
              <input type="text" placeholder="Nombre completo" value={formData.name} onChange={(e) => setFormData({ ...formData, name: e.target.value })} />
              <input type="email" placeholder="Correo electrónico" value={formData.email} onChange={(e) => setFormData({ ...formData, email: e.target.value })} />
              <input type="tel" placeholder="Número de WhatsApp" value={formData.phone} onChange={(e) => setFormData({ ...formData, phone: e.target.value })} />
              <input type="text" placeholder="Localidad o provincia" value={formData.localidad} onChange={(e) => setFormData({ ...formData, localidad: e.target.value })} />
              <select onChange={(e) => setFormData({ ...formData, material: e.target.value })}>
                <option disabled selected>¿Qué tipo de productos te interesan?</option>
                <option>Wall panel interior y exterior - perfiles de WPC</option>
                <option>Mármol de PVC</option>
                <option>Revestimientos autoadhesivos</option>
                <option>Cielorraso de PVC</option>
                <option>Pisos flotantes de SPC</option>
                <option>Deck de WPC</option>
                <option>Césped sintético</option>
                <option>Red de camuflaje</option>
                <option>Melaminas, cantos y herrajes</option>
                <option>Construcción en seco</option>
                <option>Terciados fenolicos - puntales</option>
                <option>Maderas en general</option>
                <option>Autoelevadores Jac</option>
                <option>Otros</option>
              </select>
              <select onChange={(e) => setFormData({ ...formData, consumidor: e.target.value })}>
                <option disabled selected>Tipo de cliente</option>
                <option>Consumidor final</option>
                <option>Arquitecto/a</option>
                <option>Decorador/a</option>
                <option>Yesero</option>
                <option>Constructora</option>
                <option>Carpintero</option>
                <option>Revendedor</option>
              </select>
              <button type="submit">DEJANOS TU CONSULTA</button>
            </form>
          </div>
        </div>

        {/* Slides adicionales */}
        {(isMobile ? imagesMobile : imagesDesktop).map((img, i) => (
          <div key={i} className="slider" style={{ backgroundImage: `url(${img})` }}>
            <div className="slider-img">
              <div style={{ display: 'none' }} className="slider-content">
                <h3>TÍTULO {i + 2}</h3>
                <hr />
                <h6>Descripción del slide número {i + 2} con información relevante.</h6>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Formulario mobile */}
      <form style={{ display: 'none' }} onSubmit={submitToGoogleForm} className="first-slide-form mobile">
        <h3>COMPLETÁ EL FORMULARIO PARA QUE NUESTRO EQUIPO TE CONOZCA MEJOR</h3>
        <input type="text" placeholder="Nombre completo" value={formData.name} onChange={(e) => setFormData({ ...formData, name: e.target.value })} />
        <input type="email" placeholder="Correo electrónico" value={formData.email} onChange={(e) => setFormData({ ...formData, email: e.target.value })} />
        <input type="tel" placeholder="Número de WhatsApp" value={formData.phone} onChange={(e) => setFormData({ ...formData, phone: e.target.value })} />
        <input type="text" placeholder="Localidad o provincia" value={formData.localidad} onChange={(e) => setFormData({ ...formData, localidad: e.target.value })} />
        <select onChange={(e) => setFormData({ ...formData, material: e.target.value })}>
          <option disabled selected>¿Qué tipo de productos te interesan?</option>
          <option>Wall panel interior y exterior - perfiles de WPC</option>
          <option>Mármol de PVC</option>
          <option>Revestimientos autoadhesivos</option>
          <option>Cielorraso de PVC</option>
          <option>Pisos flotantes de SPC</option>
          <option>Deck de WPC</option>
          <option>Césped sintético</option>
          <option>Red de camuflaje</option>
          <option>Melaminas, cantos y herrajes</option>
          <option>Construcción en seco</option>
          <option>Terciados fenolicos - puntales</option>
          <option>Maderas en general</option>
          <option>Autoelevadores Jac</option>
          <option>Otros</option>
        </select>
        <select onChange={(e) => setFormData({ ...formData, consumidor: e.target.value })}>
          <option disabled selected>Tipo de cliente</option>
          <option>Consumidor final</option>
          <option>Arquitecto/a</option>
          <option>Decorador/a</option>
          <option>Yesero</option>
          <option>Constructora</option>
          <option>Carpintero</option>
          <option>Revendedor</option>
        </select>
        <button type="submit">DEJANOS TU CONSULTA</button>
      </form>
    </div>
  );
};

export default Slider;
